var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"dense":"","outlined":"","multiple":"","label":"upload files"},on:{"change":_vm.add},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }